
    // IMPORTS
    import { computed, defineComponent, reactive } from 'vue';

    import { Input } from '@progress/kendo-vue-inputs'
    import { Button } from '@progress/kendo-vue-buttons'
    import { Error } from '@progress/kendo-vue-labels'
    import loginContent from './login-content.vue'

    import { AuthenticationApi, buildLocalization, RouteUtil, StringUtil } from '@/util';
    import { ILinkDTO } from '@/types/ILinkDTO'

    export default defineComponent({
        name: 'PasswordRequestPage',

        components: {
            loginContent,
            'k-input': Input,
            'k-button': Button,
            Error
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const userFromRoute = RouteUtil.getRouteParam('user');

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const state = reactive({
                email: userFromRoute,
                emailIsMissing: false,
                sendingInProgress: false,
                emailWasSent: false,
                errorMessage: ""
            })

            const publicData = { state }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const title = computed(() => localize('ForgottenPassword'))
            const links = computed<ILinkDTO[]>(() => [
                { name: localize('Back'), url: '/auth' },
            ])
            const emailHasContent = computed(() => StringUtil.hasContent(state.email))

            const computedData = { title, links, emailHasContent }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization();

            function sendEmail() {
                state.emailWasSent = false;

                const emailFilled = emailHasContent.value;
                state.emailIsMissing = !emailFilled;

                if (emailFilled) {
                    requestPasswordReset();
                }
            }

            function requestPasswordReset() {
                const api = new AuthenticationApi();
                state.sendingInProgress = true;

                api.requestPasswordReset(state.email as string)
                    .then(() => state.emailWasSent = true)
                    .catch(() => state.errorMessage = localize('unexpectedError'))
                    .finally(() => state.sendingInProgress = false);
            }


            const publicMethods = { localize, sendEmail }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
